import { createContext, ReactNode, useState } from 'react'

const defaultState = {
  open: false,
  handleOpen: () => {},
  handleClose: () => {},
}

interface ContextProviderProps {
  children: ReactNode
}

export const ModalApiKeyContext = createContext<any>(defaultState)

export function ModalApiKeyProvider({ children }: ContextProviderProps) {
  const [open, setOpen] = useState<boolean>(false)
  const [page, setPage] = useState<string>()
  const [id, setId] = useState<string>()

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  const openModalApiKey = (page: string, id: string) => {
    setPage(page)
    setId(id)
    handleOpenModal()
  }

  const openModal = (route, id) => {
    openModalApiKey(route, id)
  }

  return (
    <ModalApiKeyContext.Provider
      value={{
        id,
        open,
        handleCloseModal,
        handleOpenModal,
        openModalApiKey,
        openModal,
      }}
    >
      {children}
    </ModalApiKeyContext.Provider>
  )
}
